/**
 * @fileoverview Taskflow Component
 * @author Qiwen Luo (qluo@yext.com)
 */

import {Breadcrumbs} from '/ui/components/breadcrumbs/breadcrumbs';
import {BreadcrumbShapeJsDoc} from '/ui/components/breadcrumbs/breadcrumbshape';
import {ActionsBar, ActionsBarProps} from '/ui/components/taskflow/actionsBar/actionsBar';
import {ContentArea} from '/ui/components/taskflow/contentArea/contentArea';
import {LeftNav} from '/ui/components/taskflow/leftNav/leftNav';
import {classNames} from '/ui/lib/classnames';

import * as styles from '/ui/components/taskflow/taskflow.module.scss';
import * as Types from '/ui/components/taskflow/models';

/**
 * @typedef {{
 *  breadcrumbsList?: Array<BreadcrumbShapeJsDoc>,
 *  headerLogo?: React.ReactNode,
 *  padding?: boolean,
 *  sections: !Array<!Types.Section>,
 *  pages: !Array<!Types.PageType>,
 *  actionsBar: ActionsBarProps,
 *  selectedPageId: string,
 *  pendoId?: string,
 * }}
 */
let TaskflowProps;

/**
 * @param {TaskflowProps} props
 * @return {React.ReactElement}
 */
export function Taskflow({
  padding,
  breadcrumbsList,
  headerLogo,
  sections,
  pages,
  actionsBar,
  selectedPageId,
  pendoId,
}) {
  /** @type {?} */
  const mainPartEl = React.useRef(null);
  React.useLayoutEffect(() => {
    let h = 0;
    /** @type {?} */
    const header = document.querySelector('.js-taskflow-desktop-header');
    if (header) {
      h += header.offsetHeight;
    }
    /** @type {?} */
    const actionsBar = document.querySelector('.js-taskflow-desktop-actionsBar');
    if (actionsBar) {
      h += actionsBar.offsetHeight;
    }
    mainPartEl.current.style.setProperty('--usedHeight', `${h + 1}px`);
  }, []);
  const mainPartStyle = [styles.mainPart];
  if (padding) {
    mainPartStyle.push(styles.padding);
  }
  /** @type {?} */
  const currentPage = pages.find(page => page.id === selectedPageId);

  return (
    <div className={styles.desktopLayoutContainer}>
      <div className={classNames('js-taskflow-desktop-header', styles.header, {
        [styles.breadcrumbsPadding]: breadcrumbsList,
        [styles.logoPadding]: headerLogo,
      })}>
        {breadcrumbsList
            ? <Breadcrumbs breadcrumbsList={breadcrumbsList}/>
            : (headerLogo && headerLogo)
        }
      </div>
      <div ref={mainPartEl} className={mainPartStyle.join(' ')}>
        <div className={classNames(styles.verticalScroll, styles.leftNav)}>
          <LeftNav sections={sections}/>
        </div>
        <div className={classNames(styles.verticalScroll, styles.contentArea)}>
          <ContentArea
            layoutHeader={currentPage.layoutHeader}
            content={currentPage.content}
          />
        </div>
      </div>
      <ActionsBar
        ctas={actionsBar.ctas}
        onBack={actionsBar.onBack}
        onCancel={actionsBar.onCancel}
        onCancelDialog={actionsBar.onCancelDialog}
        padding={actionsBar.padding}
        pendoId={pendoId && pendoId + '-actions-bar'}
      />
    </div>
  );
}
